/**
 * Umami analytics helpers.
 *
 * Every function guards against a missing tracker so callers never
 * need to check whether Umami loaded.
 */

export function trackEvent(name, data = {}) {
    if (typeof window.umami?.track !== 'function') return;

    try {
        window.umami.track(name, data);
    } catch {
        // Silently ignore — analytics must never break the site.
    }
}

export function trackOutbound(url) {
    trackEvent('outbound-link', { url });
}
